import {loadStripe} from '@stripe/stripe-js'
import {Elements} from '@stripe/react-stripe-js'
// Components
import CheckoutForm from './checkout-form'
// Types
import type {StripePayload, SubmissionObject} from '../../types/submission-wizard'

// Consts
const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!)

interface StripePaymentProps {
  stripePayload: StripePayload
  paymentIsProcessing: boolean
  sendPaymentIsProcessing: (isProcessing: boolean) => void
  onCastSubmission: (submission: SubmissionObject) => Promise<boolean>
  onNext: () => void
}

const StripePayment = ({
  stripePayload,
  paymentIsProcessing,
  sendPaymentIsProcessing,
  onCastSubmission,
  onNext,
}: StripePaymentProps) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm
        stripePayload={stripePayload}
        paymentIsProcessing={paymentIsProcessing}
        sendPaymentIsProcessing={sendPaymentIsProcessing}
        onCastSubmission={onCastSubmission}
        onNext={onNext}
      />
    </Elements>
  )
}

export default StripePayment
